import { IOnlineRetailersSearchResponse } from '@models/IOnlineRetailer';
import axios from 'axios';
import qs from 'qs';

interface Params {
  readonly endpoint: string;
  readonly language: string;
  readonly from: number;
  readonly pageSize: number;
}

const onlineRetailersSearch = async ({
  endpoint,
  language,
  from,
  pageSize,
}: Params): Promise<IOnlineRetailersSearchResponse> => {
  const query = qs.stringify({
    from,
    pageSize,
    siteLanguageCode: language,
  });

  const { data } = await axios.get<IOnlineRetailersSearchResponse>(
    `${endpoint}?${query}`
  );

  return data;
};

export default onlineRetailersSearch;
